<template>
  <div>
    <custom-actions show-back>
      <el-form
        class="global-form shoufa-form"
        :model="formData"
        ref="form"
        label-width="160px"
        v-loading="loading"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item prop="specName" label="品种规格">
              {{ formData.specName || "" }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item prop="priceDiff" label="价格差(元)">
              {{ formData.priceDiff || "" }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item prop="isBulkOil" label="是否散油">
              {{
                formData.isBulkOil == "0"
                  ? "否"
                  : formData.isBulkOil == "1"
                  ? "是"
                  : ""
              }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item prop="unit" label="单位">
              {{ formData.unit || "" }}
            </el-form-item>
          </el-col>

        </el-row>

        <el-row :span="24">
          <el-col :span="24">
            <el-form-item label="图片" prop="specImage">
              <el-image
                style="width: 60px; height: 60px"
                :src="formData.specImage || YouImg"
                :preview-src-list="[formData.specImage || YouImg]"
                fit="cover"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :span="24">
            <el-form-item label="价格清单" prop="priceList">
              <el-table
                size="mini"
                stripe
                border
                :data="formData.priceList"
              >

                <el-table-column
                  min-width="120"
                  label="单价(元)"
                  prop="specPrice"
                ></el-table-column>
                <el-table-column
                  min-width="120"
                  label="数量"
                  prop="numUp"
                ></el-table-column>
                <!-- <el-table-column
                  min-width="140"
                  label="创建时间"
                  prop="ctime"
                ></el-table-column> -->
              </el-table>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>
import YouImg from '@/assets/you.png'
export default {
  name: 'PriceControlDetail',

  data() {
    return {
      YouImg,
      typeArr: [],

      formData: {
        typeId: '',
        specName: '',
        priceDiff: '',
        currentPrice: '',
        isPublished: '',
        isBulkOil: '',
        unit: '',
        productCode: '',
        specImage: '',
        priceList: []
      },

      loading: false

    }
  },
  created() {
    if (this.specId) {
      this.loadData()
    }
  },
  computed: {
    specId() {
      return this.$route.query.specId
    }
  },
  methods: {
    loadData() {
      this.loading = true
      this.$axios
        .get(this.$apis.priceControl.selectYxSpecPriceById, {
          params: { specId: this.specId }
        })
        .then(res => {
          res.priceList = res.priceList || []
          this.formData = res
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
.shoufa-form {
  width: 800px;
}

::v-deep .el-form {
  .el-input-number,
  .el-select,
  .el-cascader,
  .el-date-editor {
    width: 100%;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}
</style>
